import { ChangePasswordForm } from "@/components";

export const ChangePassword = () => {
  return <ChangePasswordForm />;
};
